import { createSlice } from '@reduxjs/toolkit';
export var authParamsState = {
  email: '',
  uuid: '',
  auth0Token: '',
  cheggMfaToken: ''
};
export var authParamsSlice = createSlice({
  name: 'authParams',
  initialState: authParamsState,
  reducers: {
    setParams: function setParams(state, _ref) {
      var payload = _ref.payload;
      state.email = payload.email;
      state.uuid = payload.uuid;
      state.auth0Token = payload.auth0Token;
      state.cheggMfaToken = payload.cheggMfaToken;
    }
  }
});